import { render, staticRenderFns } from "./addTestimonial.vue?vue&type=template&id=4ee17fee&scoped=true&"
import script from "./addTestimonial.vue?vue&type=script&lang=js&"
export * from "./addTestimonial.vue?vue&type=script&lang=js&"
import style0 from "./addTestimonial.vue?vue&type=style&index=0&id=4ee17fee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee17fee",
  null
  
)

export default component.exports